import { useState } from 'react';

export default function Services() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const services = [
    {
      icon: 'ri-tools-line',
      title: 'Handyman Services',
      description: 'Small repairs, fixture installation, drywall patching, painting touch-ups, and general maintenance',
      color: 'bg-gray-100',
      image: 'https://static.readdy.ai/image/9b35b8180c803dd171897861355a5e85/9c7b6edfe577a643a8ed02b116fc2d9b.jpeg'
    },
    {
      icon: 'ri-home-4-line',
      title: 'Residential Construction',
      description: 'Complete home building, room additions, kitchen and bathroom remodeling, structural renovations',
      color: 'bg-gray-100'
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial Construction',
      description: 'Office build-outs, retail spaces, restaurant renovations, commercial property improvements',
      color: 'bg-gray-100'
    },
    {
      icon: 'ri-archive-drawer-line',
      title: 'Fine Frank Cabinets',
      description: 'Custom kitchen cabinets, TV panels, modern and classic closets with premium finishes',
      color: 'bg-[#FF6B4A]',
      special: true,
      image: 'https://static.readdy.ai/image/9b35b8180c803dd171897861355a5e85/0ff7d637d9b07378cb9012dfc0bb4ab3.jpeg'
    }
  ];

  const handleServiceClick = (service: typeof services[0]) => {
    if (service.image) {
      setSelectedImage(service.image);
    }
  };

  return (
    <>
      <section id="services" className="py-24 bg-[#F5F1E8]">
        <div className="max-w-7xl mx-auto px-8">
          {/* Section Header */}
          <div className="mb-16">
            <p className="text-xs font-semibold text-gray-500 tracking-widest uppercase mb-3">OUR EXPERTISE</p>
            <h2 className="text-5xl font-extrabold text-gray-900 leading-tight">
              Complete Home Solutions<br />
              From Repairs to Renovations
            </h2>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-4 gap-6">
            {services.map((service, index) => (
              <div
                key={index}
                onClick={() => handleServiceClick(service)}
                className={`${service.color} rounded-xl p-8 relative transition-transform hover:scale-105 cursor-pointer`}
              >
                {service.special && (
                  <div className="absolute top-6 right-6 w-10 h-10 bg-white rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-100 transition-colors">
                    <i className="ri-arrow-right-up-line text-gray-900 text-lg"></i>
                  </div>
                )}
                
                <div className={`w-16 h-16 flex items-center justify-center mb-6 ${service.special ? 'text-white' : 'text-gray-900'}`}>
                  <i className={`${service.icon} text-4xl`}></i>
                </div>
                
                <h3 className={`text-xl font-bold mb-4 ${service.special ? 'text-white' : 'text-gray-900'}`}>
                  {service.title}
                </h3>
                
                <p className={`text-sm leading-relaxed ${service.special ? 'text-white/90' : 'text-gray-600'}`}>
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-8"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-5xl w-full">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-12 right-0 w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-gray-900 text-xl"></i>
            </button>
            <img
              src={selectedImage}
              alt="Service showcase"
              className="w-full h-auto rounded-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </>
  );
}
